import React from 'react';
import { connect } from 'react-redux';
import MenuPres from '../presentational/MenuPres';
import { selectMenuAndReset, switchView, resetSearchText, clearFilters, selectMenu } from '../state/messagingActions';

class MenuContainer extends React.Component {
  render() {
    return <MenuPres {...this.props} />;
  }
}

const mapStateToProps = (state, ownProps) => ({
  countInbox: state.messaging.countInbox,
  countDrafts: state.messaging.countDrafts,
  countSent: state.messaging.countSent,
  isMobile: ownProps.isMobile,
  isTablet: ownProps.isTablet,
  toggleDrawer: ownProps.toggleDrawer,
});

const mapDispatchToProps = {
  selectMenuAndReset,
  switchView,
  resetSearchText,
  clearFilters,
  selectMenu,
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
